import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed, onMounted, ref, watch } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { useRouter } from 'vue-router';
import { useTreasureActivityStore } from '@/stores/treasure';
import { getActivityInformations } from '@/api/common';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { Share } from '@capacitor/share';
import BauDoTesouroViewOne from '@/themes/themeOne/bauDoTesouro/bauDoTesouroView.vue';
import BauDoTesouroViewTwo from '@/themes/themeTwo/bauDoTesouro/bauDoTesouroView.vue';
import { InfoConfig, TreasureData } from './supportScript';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'bauDoTesouroView',
  setup(__props) {

const activityStore = useTreasureActivityStore()
const router = useRouter()
const themeStore = useThemeStore()

const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const descriptionHtml = ref([])
const activityConfig = ref<InfoConfig>({
    equipment_limit: '',
    ip_limit: '',
    recharge_require: '',
    turnover_require: '',
    turnover_require_times: '',
    valid_user_count: 0,
    link: '',
    reward_conf: []
})
const bannerIcon = ref('')

const dataSet = computed<TreasureData>(() => ({
    descriptionHtml: descriptionHtml.value,
    activityConfig: activityConfig.value,
    bannerIcon: bannerIcon.value
}))

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

const getActivityInfo = () => {
    loadingRef.value.open()
    let data = {
        activityId: "user_referral_reward"
    }

    getActivityInformations(data).then(res => {
        loadingRef.value.close()
        const resData = res.data
        bannerIcon.value = resData?.floatIcon
        descriptionHtml.value = JSON.parse(resData.activityIntro)
        activityConfig.value = resData.config
        activityStore.setActivityData(resData.config.recharge_require, resData.config.turnover_require, resData.config.ip_limit)
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}
const goToShare = async () => {
    let shareLink = activityConfig.value?.link //localStorage.getItem('shareLink')
    try {
      if (!shareLink) { return }
        await Share.share({
            text: shareLink,
        });
    } catch (error) {
       console.warn('Not supporting') 
    }
}

const goToUserDetails = async () => {
   router.push('/sdagusers')
}
onMounted(() => {
    getActivityInfo()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(BauDoTesouroViewOne, {
            "data-set": dataSet.value,
            onGoToShare: goToShare,
            onGoToUserDetails: goToUserDetails
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(BauDoTesouroViewTwo, {
            "data-set": dataSet.value,
            onGoToShare: goToShare,
            onGoToUserDetails: goToUserDetails
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(StatusPopup, {
      content: _ctx.$t('common.loading'),
      isLoading: true
    }, null, 8, ["content"]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})